import getSafePlugin from "./getSafe";
import toFixedPlugin from "./toFixed";
import smartFocusPlugin from "./smartFocus";
import keyCodeAliases from "./keyCodeAliases";

export default {
	getSafePlugin,
	toFixedPlugin,
	smartFocusPlugin,
	keyCodeAliases
};
